export const getUpdatedVariantIds = (variantIds, variantId, isOptedIn) => {
  if (!isOptedIn) {
    return [...variantIds, variantId];
  } else {
    return variantIds.filter(
      existingVariantId => existingVariantId !== variantId
    );
  }
};
